import React from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import {useTheme} from "@emotion/react";
import {ROUND_BOX} from "../../_presentational/buttons";

/*
    props
    is_expired : bool = course의 expired 여부
 */
const ClassBadge = (props) => {
    // css style
    const {css} = useComponentStyle(props.is_expired);

    return <ROUND_BOX css={css.class_badge_css}>{props.is_expired ? "수강만료" : "수강중"}</ROUND_BOX>;
};
export default ClassBadge;

export const useComponentStyle = (is_expired) => {
    const theme = useTheme();
    return {
        css: {
            class_badge_css: css({
                borderRadius: "15px",
                border: `1px solid ${is_expired ? theme.colors.lg3 : theme.colors.bearu_primary}`,
                color: is_expired ? theme.colors.dg2 : theme.colors.bearu_primary,
                fontSize: theme.font_size.f14,
                padding: ".3em .6em",
            }),
        },
    };
};
